import { CONFIGURATOR_STEPS, CONFIGURATOR_THEME_CATEGORIES } from '../constants';
import { ConfiguratorStep, ConfiguratorThemeCategory, ConfiguratorTrafficDetails } from '../types';

export function getInitialStep(steps: ConfiguratorStep[] = CONFIGURATOR_STEPS): ConfiguratorStep {
  return steps[0];
}

export function getInitialThemeCategory(
  categories: ConfiguratorThemeCategory[] = CONFIGURATOR_THEME_CATEGORIES,
): ConfiguratorThemeCategory {
  return categories[0];
}

export function getInitialTrafficDetailsState(): ConfiguratorTrafficDetails {
  return {
    siteName: '',
    totalPlayers: 0,
    totalBets: 0,
    totalDeposits: 0,
    topPlayers: [],
  };
}
